import { Box } from '@mui/joy';
import { ChapterList } from './ChapterList';
import { ReturnToHomepageButton } from './ReturnToHomepageButton';
import { useChapterConfig } from '../../hooks/useChapterConfig';

export const NavMenu = ({ isActive }: { isActive?: boolean }) => {
	const { getEnabledChapters } = useChapterConfig();
	const enabledChapters = getEnabledChapters();

	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'space-between',
				flexGrow: 1
			}}
		>
			<Box
				sx={{
					display: 'flex',
					flexDirection: { xs: 'column', md: 'row' },
					backgroundColor: '#ffffff',
					overflowY: 'auto',
					width: 'fit-content'
				}}
			>
				{enabledChapters.map((chapterConfig) => (
					<ChapterList
						key={chapterConfig.type}
						chapter={chapterConfig.chapter}
						header={chapterConfig.header}
						subheader={chapterConfig.subheader}
						links={chapterConfig.links}
						backgroundColor='#ffffff'
						href={chapterConfig.url}
						isActive={isActive}
						disabled={chapterConfig.disabled}
						disabledText={chapterConfig.disabledText}
					/>
				))}
			</Box>
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'flex-end',
					padding: '37px'
				}}
			>
				<ReturnToHomepageButton />
			</Box>
		</Box>
	);
};
